module.exports = __webpack_public_path__ + "static/media/deletematch.6e7090f0.svg";